import { render, staticRenderFns } from "./profileKycActivityLog.vue?vue&type=template&id=7cc04fc4"
import script from "./profileKycActivityLog.vue?vue&type=script&lang=js"
export * from "./profileKycActivityLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports